export const isNotNullOrUndefined = <T>(t: T | null | undefined): t is T => {
  return t !== null && t !== undefined;
};

export const isNullOrUndefined = <T>(
  t: T | null | undefined,
): t is null | undefined => {
  return t === null || t === undefined;
};
